import React from 'react';

/**
 * Barra colorata, ancorata al bordo inferiore dell'immagine prodotto —
 * accorciata (inset laterale maggiore) e con soli angoli superiori
 * arrotondati, per restare "attaccata" al bordo (richiesta utente
 * 10/07/2026: rimosso il radius sui due angoli inferiori).
 *
 * Per Tricromia / Colori: tre sezioni Ciano · Magenta · Giallo.
 * Per tutti gli altri: colore pieno.
 */

const SOLID: Record<string, string> = {
  // Colori base NTS TABHHCL
  'nero':           '#1c1c1c',
  'nero chiaro':    '#4b4b4b',
  'nero matte':     '#2a2a2a',
  'photo/nero':     '#78350f',
  'ciano':          '#06b6d4',
  'ciano chiaro':   '#67e8f9',
  'photo-ciano':    '#0891b2',
  'magenta':        '#db2777',
  'magenta chiaro': '#f472b6',
  'photo-magenta':  '#be185d',
  'giallo':         '#f59e0b',
  'giallo chiaro':  '#fcd34d',
  'photo-giallo':   '#d97706',
  'grigio':         '#9ca3af',
  'foto':           '#78350f',
  'blu':            '#2563eb',
  'verde':          '#16a34a',
  'rosso':          '#dc2626',
  'marrone':        '#92400e',
  'viola':          '#7c3aed',
  'nero/rosso':     '#7f1d1d',
  'trasparente':    '#cbd5e1',
  'gloss optimizer':'#e0f2fe',
};

// Ciano · Magenta · Giallo (Tricromia = 3 colori, es. ink cartridge CMY)
const CMY = ['#06b6d4', '#db2777', '#f59e0b'] as const;
// Nero · Ciano · Magenta · Giallo (Quadricromia = 4 colori, es. OPC Drum CMYK)
const CMYK = ['#1c1c1c', '#06b6d4', '#db2777', '#f59e0b'] as const;

// Esportati per riuso in ColorDot.tsx (pallino descrittivo colore nel dettaglio prodotto)
export const COLOR_SOLID_MAP = SOLID;
export const COLOR_CMY = CMY;
export const COLOR_CMYK = CMYK;

interface Props { color?: string | null }

export function ColorBar({ color }: Props) {
  if (!color || color === '-') return null;
  const lower = color.toLowerCase();
  const isTri  = lower === 'tricromia' || lower === 'colori';
  const isQuad = lower === 'quadricromia';
  const solid  = SOLID[lower];

  // Se il colore non ha un mapping noto, non mostrare la barra
  if (!isTri && !isQuad && !solid) return null;

  return (
    <div
      className="absolute bottom-0 left-8 right-8 h-[4px] rounded-t-full overflow-hidden z-10 shadow-sm"
      aria-hidden
    >
      {isTri ? (
        <div className="flex h-full">
          {CMY.map((c, i) => (
            <div key={i} className="flex-1" style={{ backgroundColor: c }} />
          ))}
        </div>
      ) : isQuad ? (
        <div className="flex h-full">
          {CMYK.map((c, i) => (
            <div key={i} className="flex-1" style={{ backgroundColor: c }} />
          ))}
        </div>
      ) : (
        <div className="h-full" style={{ backgroundColor: solid }} />
      )}
    </div>
  );
}
